const OTP_VERIFIED_KEY = "otpVerified";

export const setOtpVerified = (verified) => {
  if (verified) {
    sessionStorage.setItem(OTP_VERIFIED_KEY, "true");
  } else {
    sessionStorage.removeItem(OTP_VERIFIED_KEY);
  }
};

export const isOtpVerified = () =>  sessionStorage.getItem(OTP_VERIFIED_KEY) === "true";

export const clearOtpVerified = () => {
  sessionStorage.removeItem(OTP_VERIFIED_KEY);
};
